import { GridColDef } from "@mui/x-data-grid";
import { IconButton, Button } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import dayjs from "dayjs";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateSatisfacaoClientePesquisaListaColumnDefinition
 */

type Props = {
  onActionEditar: (idPesquisaSatisfacaoCliente: number | null, openState: boolean) => void;
  onActionDelete: (idPesquisaSatisfacaoCliente: number | null, openState: boolean) => void;
  onActionExportar: (idPesquisaSatisfacaoCliente: number) => void;
};

export const GenerateSatisfacaoClientePesquisaListaColumnDefinition = ({
  onActionEditar,
  onActionDelete,
  onActionExportar,
}: Props): GridColDef[] => {

  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Finalizada";
      case 0:
        return "Em aberto";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "yellow";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Finalizada";
      case 0:
        return "Em aberto";
      default:
        return "?";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "",
      minWidth: 110,
      width: 110,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeItemStatusTitle(value)}
            color={computeItemStatusColor(value)}
            description={computeItemStatusDescription(value)}
          />
        </div>
      )
    },
    {
      field: "pesquisa",
      filterable: false,
      headerName: "Pesquisa",
      flex: 1,
      minWidth: 200,
      sortable: false,
      align: 'left',
      valueGetter: (_, row) => ({
        codigo: row['codigo'] as string,
        descricao: row['descricao'] as string,
      }),
      renderCell: ({ value: { codigo, descricao } }) =>
        <span>{codigo && descricao ? `${codigo} - ${descricao}` : ''}</span>
    },
    {
      field: "respondidaPor",
      filterable: false,
      headerName: "Respondida Por",
      width: 150,
      minWidth: 150,
      sortable: false,
      align: 'left',
    },
    {
      field: "local",
      filterable: false,
      headerName: "Local",
      width: 150,
      minWidth: 150,
      sortable: false,
      align: 'left',
    },
    {
      field: "data",
      filterable: false,
      headerName: "Data",
      width: 100,
      minWidth: 100,
      sortable: false,
      align: 'left',
      renderCell: ({ value }) => {
        return (
          <span>{value !== null ? dayjs.utc(value).local().format('DD/MM/YYYY') : ''}</span>
        );
      }
    },
    {
      field: "percPonto",
      filterable: false,
      headerName: "Índice de Satisfação",
      width: 150,
      minWidth: 150,
      sortable: false,
      align: 'left',
      renderCell: ({ value }) => {
        const formatedValue = value !== null
          ? new Intl.NumberFormat("pt-BR", { style: 'percent', minimumFractionDigits: 2 }).format(value)
          : null;

        return (
          <span>{formatedValue !== null ? formatedValue : ''}</span>
        );
      },
    },
    {
      field: 'idPesquisaSatisfacaoCliente',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                onActionEditar(value, true);
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => { onActionDelete(value, true); }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
    {
      field: "exportar",
      filterable: false,
      headerName: "Exportar",
      width: 110,
      sortable: false,
      resizable: false,
      valueGetter: (_, rows) => ({
        idPesquisaSatisfacaoCliente: rows['idPesquisaSatisfacaoCliente'],
      }),
      renderCell: ({ value: { idPesquisaSatisfacaoCliente } }) => {
        return (
          <Button
            onMouseDown={e => {
              onActionExportar(idPesquisaSatisfacaoCliente);
              e.preventDefault();
            }}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.3rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
              width: '5rem',
            }}>
            Exportar
          </Button>
        );
      },
    },
  ];
}